export function log(...props:any) {
  if (process.env.NODE_ENV === "development") {
    console.log(props);
  }
}

export const openUrl = (url:string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export const ACCESS_TOKEN = 'kfaAcstk';
export const AUTH_TOKEN = 'authT';

export const radio프로그램레벨 = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED', 'ETC'];

export const radio프로그램영역 = ['PASS', 'DRIBBLE', 'BALL_FEELING', 'SHOOTING', 'MIX', 'ETC'];

export function 레벨번역(text: string) {
  if (text === 'BEGINNER') {
    return '초급';
  } else if (text === 'INTERMEDIATE') {
    return '중급';
  } else if (text === 'ADVANCED') {
    return '상급';
  } else if (text === 'ETC') {
    return '기타';
  }
}

export function 영역번역(text: string) {
  if (text === 'DRIBBLE') {
    return '드리블';
  } else if (text === 'PASS') {
    return '패스';
  } else if (text === 'SHOOTING') {
    return '슈팅';
  }else if (text === 'BALL_FEELING') {
    return '볼필링';
  } else if (text === 'MIX') {
    return '복합 움직임';
  } else if (text === 'ETC') {
    return '기타';
  }
}

export const formatStartDate = (timestamp: number) => {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
  }
  return date.toLocaleDateString('ko-KR', options)
}

export const formatActivityDate = (timestamp: number) => {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
  }
  return date.toLocaleDateString('ko-KR', options)
}

export const formatDateToDot = (date: string) => {
  const dotSeparatedDate = date
  .replace('년', '.')
  .replace('월', '.')
  .replace('일', '');

  return dotSeparatedDate;
}
